import shouldForwardProp from '@styled-system/should-forward-prop'
import styled from '@emotion/styled'

import {Theme} from 'src/styles/theme'

interface Props {
  src: string
  force?: boolean
}

const backgroundStyles = (src: string, theme: Theme) => ({
  backgroundImage: `url(${src})`,
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  margin: `-${theme.space[2]}`,
  padding: theme.space[2],
})

const HoverBackground = styled('div', {shouldForwardProp})<Props>(
  ({theme, src}) => ({
    '&:hover': backgroundStyles(src, theme),
  }),
  ({force = false, src, theme}) => force && backgroundStyles(src, theme)
)

export default HoverBackground
